import { NavState } from 'models'
import { ALERTS_PATH } from 'lib/constants'
import { RouteComponentProps } from 'react-router-dom'
import { AlertSession, AppNotification } from 'lib/types'

export const onAlertNotificationClick = (alertSession: AlertSession, history: RouteComponentProps['history']) => {
  NavState.selectOrganization(alertSession?.orgId)
  history.push(`${ALERTS_PATH}/${alertSession.id}`)
}
